/**
 * English `/news` is the unprefixed newsroom. Every other website locale has
 * `/{locale}/news`. If the visitor already chose that locale, leave `/news`
 * before the English newsroom paints.
 */
import { NEWS_LOCALES } from "./news-locales.mjs";

export const PREFIXED_NEWS_LOCALES = NEWS_LOCALES.filter((code) => code !== "en");

export const NEWS_NAV_LABELS = {
  en: "News",
  es: "Actualidad",
  fr: "Actualités",
  de: "Aktuelles",
  it: "Notizie",
  pt: "Notícias",
  "pt-BR": "Notícias",
  nl: "Nieuws",
  pl: "Aktualności",
  sv: "Nyheter",
  da: "Nyheder",
  no: "Nyheter",
  fi: "Uutiset",
  cs: "Aktuality",
  sk: "Aktuality",
  sl: "Novice",
  hr: "Vijesti",
  hu: "Hírek",
  ro: "Știri",
  el: "Νέα",
  ca: "Actualitat",
  ru: "Новости",
  uk: "Новини",
  tr: "Haberler",
  ar: "الأخبار",
  he: "חדשות",
  ur: "خبریں",
  hi: "समाचार",
  bn: "খবর",
  gu: "સમાચાર",
  mr: "बातम्या",
  ta: "செய்திகள்",
  te: "వార్తలు",
  pa: "ਖ਼ਬਰਾਂ",
  ja: "ニュース",
  ko: "뉴스",
  "zh-Hans": "新闻",
  "zh-Hant": "新聞",
  id: "Berita",
  ms: "Berita",
  vi: "Tin tức",
  th: "ข่าว",
};

export function newsNavLabel(locale) {
  return NEWS_NAV_LABELS[locale] || NEWS_NAV_LABELS.en;
}

export const NEWS_LOCALE_REDIRECT_SCRIPT = `(function(){try{var p=location.pathname.replace(/\\/+$/,"")||"/";if(p!=="/news")return;var raw=localStorage.getItem("rr_locale")||navigator.language||"";var tag=String(raw).trim().replace(/_/g,"-");var codes=${JSON.stringify(PREFIXED_NEWS_LOCALES)};function pick(v){if(!v)return"";var lower=v.toLowerCase();for(var i=0;i<codes.length;i++){if(codes[i].toLowerCase()===lower)return codes[i];}var bits=lower.split("-").filter(Boolean);if(bits.length>=2){var two=bits[0]+"-"+bits[1];for(var k=0;k<codes.length;k++){if(codes[k].toLowerCase()===two)return codes[k];}}if(bits[0]==="zh")return"zh-Hans";for(var j=0;j<codes.length;j++){if(codes[j].toLowerCase()===bits[0])return codes[j];}return"";}var next=pick(tag);if(!next)return;location.replace("/"+next+"/news"+location.search+location.hash);}catch(e){}})();`;
